/* Winkelwagen-drawer: voordeelblok (stapelkorting + gratis verzending) — Rebelz Archive */
(function () {
  'use strict';

  function money(cents) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }
  function parseJSON(s, fb) { try { return JSON.parse(s); } catch (e) { return fb; } }

  function init() {
    var box = document.querySelector('[data-drawer-perks]');
    if (!box) return;

    var threshold = parseInt(box.dataset.shipThreshold, 10) || 0;
    var tiers = parseJSON(box.dataset.tiers, []).filter(function (t) { return t && t.q > 1; })
      .sort(function (a, b) { return a.q - b.q; });
    var maxQ = tiers.length ? tiers[tiers.length - 1].q : 0;

    var tierText = box.querySelector('[data-perks-tier-text]');
    var track = box.querySelector('[data-perks-track]');
    var labels = box.querySelector('[data-perks-labels]');
    var shipEl = box.querySelector('[data-perks-ship]');
    var shipText = box.querySelector('[data-perks-ship-text]');

    /* Track: één balk met een stip per staffel */
    if (track && tiers.length) {
      track.innerHTML = '<span class="drawer-perks__fill" data-perks-fill></span>';
      labels.innerHTML = '';
      tiers.forEach(function (t) {
        var pct = Math.round(t.q / maxQ * 100);
        var dot = document.createElement('span');
        dot.className = 'drawer-perks__dot';
        dot.style.left = pct + '%';
        dot.setAttribute('data-q', t.q);
        track.appendChild(dot);
        var lab = document.createElement('span');
        lab.className = 'drawer-perks__label';
        lab.style.left = pct + '%';
        lab.setAttribute('data-q', t.q);
        lab.innerHTML = '<b>−' + t.p + '%</b><small>' + t.q + ' items</small>';
        labels.appendChild(lab);
      });
    }

    function render(cart) {
      var n = cart.item_count || 0;
      box.hidden = n === 0;
      if (n === 0) return;

      if (tiers.length && tierText) {
        var cur = null, next = null;
        tiers.forEach(function (t) { if (n >= t.q) cur = t; else if (!next) next = t; });
        var fill = box.querySelector('[data-perks-fill]');
        if (fill) fill.style.width = Math.min(100, Math.round(n / maxQ * 100)) + '%';
        box.querySelectorAll('[data-q]').forEach(function (s) {
          s.classList.toggle('is-reached', n >= parseInt(s.dataset.q, 10));
        });
        box.classList.toggle('is-max', !next);
        var left = next ? next.q - n : 0;
        var itemWord = left === 1 ? 'item' : 'items';
        if (!cur && next) {
          tierText.innerHTML = 'Nog <strong>' + left + ' ' + itemWord + '</strong> voor <strong>' + next.p + '% stapelkorting</strong>';
        } else if (cur && next) {
          tierText.innerHTML = '<strong>' + cur.p + '% stapelkorting</strong> actief · nog ' + left + ' ' + itemWord + ' voor ' + next.p + '%';
        } else if (cur) {
          tierText.innerHTML = '<strong>' + cur.p + '% stapelkorting</strong> actief — het maximale voordeel';
        }
      }

      if (shipEl && shipText && threshold > 0) {
        var total = cart.total_price || 0;
        var reached = total >= threshold;
        shipEl.classList.toggle('is-reached', reached);
        shipText.innerHTML = reached
          ? '<strong>Gratis verzending</strong> op deze bestelling'
          : 'Nog <strong>' + money(threshold - total) + '</strong> tot gratis verzending';
      }
    }

    var pending = null;
    function refresh() {
      clearTimeout(pending);
      pending = setTimeout(function () {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(render)
          .catch(function () {});
      }, 60);
    }

    document.addEventListener('bentior:cart', function (e) { if (e.detail && e.detail.items) render(e.detail); else refresh(); });

    /* theme.js rendert de regels opnieuw bij elke verversing; daarop haken we in. */
    var items = document.querySelector('[data-drawer-items]');
    if (items && window.MutationObserver) {
      new MutationObserver(refresh).observe(items, { childList: true });
    }
    var countEl = document.querySelector('[data-drawer-count]');
    if (countEl && window.MutationObserver) {
      new MutationObserver(refresh).observe(countEl, { childList: true, characterData: true, subtree: true });
    }
    refresh();
  }

  /* Upsells als lijstregels (thumb · titel/prijs/varianten · knop rechts).
     theme.js bouwt de kaarten; hier zetten we de knop naast de kaart en maken de selects leesbaar. */
  function initUpsellRows() {
    var track = document.querySelector('[data-upsell-track]');
    if (!track) return;
    function pretty(v) { return v === 'SM' ? 'S/M' : v === 'LXL' ? 'L/XL' : v; }
    function upgrade() {
      track.querySelectorAll('.upsell-card:not(.is-row)').forEach(function (card) {
        card.classList.add('is-row');
        var ctr = card.querySelector('.upsell-card__controls');
        if (ctr) {
          ctr.querySelectorAll('select').forEach(function (sel) {
            var lab = sel.getAttribute('aria-label') || '';
            Array.prototype.forEach.call(sel.options, function (o) {
              o.textContent = (lab ? lab + ': ' : '') + pretty(o.value);
            });
            if (sel.options.length < 2) sel.hidden = true;
          });
          var btn = ctr.querySelector('.upsell-card__add');
          if (btn) { btn.textContent = 'Toevoegen'; card.appendChild(btn); }
          if (!ctr.querySelector('select:not([hidden])')) ctr.remove();
        }
        var link = card.querySelector('.upsell-card__add--link');
        if (link) link.textContent = 'Bekijk';
      });
    }
    if (window.MutationObserver) new MutationObserver(upgrade).observe(track, { childList: true });
    upgrade();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initUpsellRows);
  else initUpsellRows();

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
